export default __webpack_public_path__ + "static/media/DoneIcon.25777270.svg";